module.exports = __webpack_public_path__ + "img/product03.2b5a0fcf.png";